import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CheckBox from './CheckBox';
import FieldBase from './FieldBase';

export default class MultiSelect extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    values: PropTypes.array,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    options: PropTypes.array,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    values: [],
  };

  optionChecked = (value, isChecked) => {
    let newValues;

    if (!isChecked) {
      newValues = this.props.values.filter(v => v != value);
    } else {
      newValues = this.props.values.concat(value);
    }

    this.props.onChange(newValues);
  };

  render() {
    return (
      <FieldBase {...this.props}>
        {this.props.options.map(option => {
          return (
            <CheckBox
              label={option.label}
              value={option.value}
              checked={this.props.values.includes(option.value)}
              onChange={isChecked => this.optionChecked(option.value, isChecked)}
              key={option.id}
            />
          );
        })}
      </FieldBase>
    );
  }
}
